import React from 'react';
import styled from 'styled-components';

const Track = styled.button<{ $on: boolean }>`
  position: relative;
  width: 42px;
  height: 24px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  padding: 0;
  background: ${(p) => (p.$on ? p.theme.primary : p.theme.lightGray)};
  transition: background 0.2s ease;

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

const Knob = styled.span<{ $on: boolean }>`
  position: absolute;
  top: 3px;
  left: ${(p) => (p.$on ? '21px' : '3px')};
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
  transition: left 0.2s ease;
`;

interface SwitchProps {
  checked: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

export const Switch: React.FC<SwitchProps> = ({ checked, onChange, disabled }) => (
  <Track
    type="button"
    role="switch"
    aria-checked={checked}
    $on={checked}
    disabled={disabled}
    onClick={() => onChange(!checked)}
  >
    <Knob $on={checked} />
  </Track>
);

export default Switch;
